"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ResponsiveIframe = function ResponsiveIframe(_ref) {
  var iframeProps = _ref.iframeProps;
  var iframeRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({
      width: 0,
      height: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dimensions = _useState2[0],
    setDimensions = _useState2[1];
  var calculateDimensions = function calculateDimensions() {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;

    // Get the y position of the iframe (or its container) from the top of the window
    var iframeTop = iframeRef.current.getBoundingClientRect().top;

    // Calculate the available height for the iframe by subtracting the iframe's top position from the window height
    var availableHeight = windowHeight - iframeTop - 20; // Subtract 20 for some padding

    // Calculate width and height to maintain a 16:9 aspect ratio
    var widthBasedOnHeight = availableHeight * (16 / 9);
    var heightBasedOnWidth = windowWidth * (9 / 16);
    var width = 0;
    var height = 0;

    // If width based on height overflows the window width, use the window's width
    if (widthBasedOnHeight <= windowWidth) {
      width = widthBasedOnHeight;
      height = availableHeight;
    } else {
      width = windowWidth;
      height = heightBasedOnWidth;
    }
    setDimensions({
      width: width,
      height: height
    });
  };
  (0, _react.useEffect)(function () {
    calculateDimensions();
    window.addEventListener('resize', calculateDimensions);
    return function () {
      window.removeEventListener('resize', calculateDimensions);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: iframeRef
  }, /*#__PURE__*/_react["default"].createElement("iframe", _extends({}, iframeProps, {
    height: dimensions.height,
    style: {
      border: 'none'
    },
    title: iframeProps.title,
    width: dimensions.width,
    allowFullScreen: iframeProps.allowfullscreen || true
  })));
};
var _default = exports["default"] = ResponsiveIframe;